import Vue from 'vue'
import Router from 'vue-router'

import Login from '../views/login'
import Register from '../views/register'

import SideMenu from '../components/sidemenu/SideMenu'

import Landing2 from '../views/Landing2'

import Magazines from "../components/landingSwiper/magazines.vue"
import Novel from "../components/landingSwiper/novels.vue"
import Children from "../components/landingSwiper/children.vue"

import ViewContent from "../views/ViewContent"
import ViewAll from "../views/ViewAll"

import MyAccount from "../views/MyAccount"

Vue.component("App-SideMenu", SideMenu);

Vue.component("App-Magazines",Magazines);
Vue.component("App-Novel",Novel);
Vue.component("App-Children",Children);

import No1_Majalah from "../components/landingSwiper/No1_Majalah.vue"
import No2_Fiksyen from "../components/landingSwiper/No2_Fiksyen.vue"
import No3_Agama from "../components/landingSwiper/No3_Agama.vue"
import No4_BukanFiksyen from "../components/landingSwiper/No4_BukanFiksyen.vue"
import No5_Kanak from "../components/landingSwiper/No5_Kanak.vue"

Vue.component("App-No1Majalah",No1_Majalah);
Vue.component("App-No2Fiksyen",No2_Fiksyen);
Vue.component("App-No3Agama",No3_Agama);
Vue.component("App-No4BukanFiksyen",No4_BukanFiksyen);
Vue.component("App-No5Kanak",No5_Kanak);

Vue.use(Router);
export default new Router
({
    // mode: 'history',
    mode: 'hash',
    base: __dirname,
    routes: [{
                name: 'landing',
                path: '',
                component: Landing2
            },
            {    
                name: 'viewContent',
                path: '/viewContent',
                component: ViewContent
            },
            
            {
                name: 'ViewAll',
                path: '/ViewAll',
                component: ViewAll
            },

            {
                name: 'login',
                path: '/login',
                component: Login
            },
            {
                name: 'MyAccount',
                path: '/MyAccount',
                component: MyAccount
            },
            /*{
                name: 'register',
                path: '/register',
                component: Register
            },*/
            {
                path: '*',
                redirect: ''
            },
    ]
})


// WEBPACK FOOTER //
// ./client/router/index.js